export default __webpack_public_path__ + "static/media/(10).34be7e75.jpg";